import { render, staticRenderFns } from "./initializationDialog.vue?vue&type=template&id=3d552c9a&scoped=true&"
import script from "./initializationDialog.vue?vue&type=script&lang=js&"
export * from "./initializationDialog.vue?vue&type=script&lang=js&"
import style0 from "./initializationDialog.vue?vue&type=style&index=0&id=3d552c9a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d552c9a",
  null
  
)

export default component.exports